export const getTotpUrl = (email: string, secret: string) => {
  return `otpauth://totp/Stablehouse:${email}?secret=${secret}&issuer=Stablehouse`;
};
